import {Component, ViewEncapsulation, Sanitizer, SecurityContext, Input} from "@angular/core";
import {StateService} from "../../service/state";
import {ApiService} from "../../service/api";
import {ActivatedRoute} from "@angular/router";
import {sanitizeHtml} from "@angular/platform-browser/src/security/html_sanitizer";
import {sanitizeUrl} from "@angular/platform-browser/src/security/url_sanitizer";
import {CartService} from "../../service/cart";
import {CheckoutComponent} from "../checkout/checkout.component";

@Component({
    selector: 'app-cart',
    templateUrl: './cart.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: [
        './cart.scss'
    ]
})
export class CartOverviewComponent {

    @Input('checkout')
    public checkout: CheckoutComponent
    public items:any = [];
    constructor(public stateService: StateService,
                public apiService: ApiService,
                public route: ActivatedRoute,
                public cart: CartService) {
        stateService.setState('title', 'Warenkorb');
    }

    public next() : void {
        if(this.checkout) {
            this.checkout.next();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/cart/cart.ts